import { Component, NgZone } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../auth/auth.service';
import { isCountryCodeBelgian } from '../../../shared/countries/country-service';

@Component({
  selector: 'app-home-introduction-pop-up',
  templateUrl: './home-introduction-pop-up.component.html',
  styleUrls: ['./home-introduction-pop-up.component.scss'],
})
export class HomeIntroductionPopUpComponent {
  constructor(
    public dialogRef: MatDialogRef<HomeIntroductionPopUpComponent>,
    private readonly ngZone: NgZone,
    private readonly authService: AuthService,
  ) {}

  get paragraphKey(): string {
    return isCountryCodeBelgian(this.authService.getCountry())
      ? 'home.pop_up.paragraph_1_be'
      : 'home.pop_up.paragraph_1';
  }

  onClose(): void {
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }
}
